import React from 'react';
import timelineElements from '../utils/TimelineElement.js';

import { ReactComponent as WorkIcon } from '../assets/work.svg';
import { ReactComponent as SchoolIcon } from '../assets/school.svg';

import '../styles/MyExperience.styled.css';
import {
  SectionTitle,
  Heading,
  BlueText,
} from '../styles/Global.styled.js';

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';

import 'react-vertical-timeline-component/style.min.css';

function MyExperience() {
  const workIconStyles = { background: '#8b5cf6' };
  const schoolIconStyles = { background: '#f59e0b' };

  return (
    <div className="experience-section">
      <div className="experience-wrapper">
        <SectionTitle align="center">Experience</SectionTitle>
        <Heading as="h2" size="h2" align="center">
          My <BlueText>Journey</BlueText>
        </Heading>
      </div>

      <VerticalTimeline lineColor="#1e293b">
        {timelineElements.map((element) => {
          const isWork = element.icon === 'work';

          return (
            <VerticalTimelineElement
              key={element.id}
              date={element.date}
              dateClassName="date"
              iconStyle={isWork ? workIconStyles : schoolIconStyles}
              icon={isWork ? <WorkIcon /> : <SchoolIcon />}
            >
              <div className="company-header">
                {element.imag && (
                  <img
                    src={element.imag}
                    alt={element.title}
                    className="company-logo"
                  />
                )}
                <div className="company-info">
                  <h3 className="vertical-timeline-element-title">
                    {element.title}
                  </h3>
                  <h5 className="vertical-timeline-element-subtitle">
                    {element.location}
                  </h5>
                </div>
                {element.link && (
                  <a
                    className="view-link"
                    href={element.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View
                  </a>
                )}
              </div>
              <p id="description">{element.description}</p>
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
}

export default MyExperience;
